import { Portal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SiteSidenavService {
   private siteStartSidenavPortal = new BehaviorSubject<SideNavPortal<any> | null>(null);

   private siteEndSidenavPortal = new BehaviorSubject<SideNavPortal<any> | null>(null);

   siteSidenavPortal(position: 'end' | 'start'): Observable<SideNavPortal<any> | null> {
      return position === 'end' ? this.siteEndSidenavPortal.asObservable() : this.siteStartSidenavPortal.asObservable();
   }

   setSiteSidenavPortal(portal: SideNavPortal<any> | null): void {
      if (portal && portal.position === 'end') {
         this.siteEndSidenavPortal.next(portal);
      } else if (portal && portal.position === 'start') {
         this.siteStartSidenavPortal.next(portal);
      } else if (portal === null) {
         this.siteEndSidenavPortal.next(null);
         this.siteStartSidenavPortal.next(null);
      } else {
         throw new Error();
      }
   }
}

export interface SideNavPortal<T> extends Portal<T> {
   position: 'end' | 'start';
}
